import type {
  ContactCreateInput,
  ContactUpdateInput,
  ContactsListOptions,
  IContactsRepository,
} from '../repositories/IContactsRepository.js';

interface Deps { contactsRepository: IContactsRepository; }

export function createListContactsUseCase({ contactsRepository }: Deps) {
  return (options: ContactsListOptions) => contactsRepository.list(options);
}

export function createGetContactByIdUseCase({ contactsRepository }: Deps) {
  return (id: string) => contactsRepository.getById(id);
}

export function createCreateContactUseCase({ contactsRepository }: Deps) {
  return (input: ContactCreateInput) => contactsRepository.create(input);
}

export function createUpdateContactUseCase({ contactsRepository }: Deps) {
  return ({ id, data }: { id: string; data: ContactUpdateInput }) => contactsRepository.update(id, data);
}

export function createDeleteContactUseCase({ contactsRepository }: Deps) {
  return (id: string) => contactsRepository.delete(id);
}
